import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_convert_dates_to_warehouse_timezonesService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { warehouseIds: number[], dates: any[], $top?: number, $skip?: number }): Promise<{ result?: { Id?: number, TimeZoneId?: string, TimeZone?: string, Offset?: number }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil(inParams.dates)) {
      missingRequiredInParams.push('\'dates\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_convert_dates_to_warehouse_timezones/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds?: number[], dates?: any[], $keys: number[] }): Promise<{ result?: { Id?: number, TimeZoneId?: string, TimeZone?: string, Offset?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_convert_dates_to_warehouse_timezones/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds: number[], dates: any[]    }) {
        if(isNil(inParams.warehouseIds)) {
          return true; 
        }
        if(isNil(inParams.dates)) {
          return true; 
        }
      return false;
    }
}
